import { defaultTransition } from './transitions';

export const scaleOutIn = {
    exit: {
        scale: 0.5,
        opacity: 0,
        transition: defaultTransition,
    },
    initial: {
        scale: 0.5,
        opacity: 0,
        transition: defaultTransition,
    },
    animate: {
        scale: 1,
        opacity: 1,
        transition: defaultTransition,
    },
};

export const slideInOutTopToBottom = {
    initial: {
        y: -30,
        opacity: 0,
    },
    animate: {
        y: 0,
        opacity: 1,
        transition: {
            ...defaultTransition,
            delay: 0.05,
        },
    },
    exit: {
        y: 30,
        opacity: 0,
        transition: {
            ...defaultTransition,
            delay: 0.05,
        },
    },
};

export const fadeInOut = {
    exit: {
        opacity: 0,
        transition: defaultTransition,
    },
    initial: {
        opacity: 0,
        transition: defaultTransition,
    },
    animate: {
        opacity: 1,
        transition: defaultTransition,
    },
};

export const slideFadeInOut = {
    exit: {
        x: -60,
        opacity: 0,
        transition: defaultTransition,
    },
    initial: {
        x: -60,
        opacity: 0,
        transition: defaultTransition,
    },
    animate: {
        x: 0,
        opacity: 1,
        transition: defaultTransition,
    },
};
